import { useContext } from "react";
import { AppContext } from "@/providers/AppContextProvider";

export const useSocialCoachSession = () => {
  const { session } = useContext(AppContext);

  return {
    session,
    userId: session?.userId,
    fullName: session?.fullName,
    playerId: session?.playerId,
    coachId: session?.coachId,
    isCoach: ["COACH", "ASSISTANT_COACH"].includes(session?.userRole || ""),
    isPlayer: session?.userRole === "PLAYER",
    isAssistantCoach: session?.userRole === "ASSISTANT_COACH",
    isMainCoach: session?.userRole === "COACH",
    isAdmin: session?.userRole === "ADMIN",
    isEditor: session?.userRole === "EDITOR",
    supportEmail: session?.supportEmail || "support@socialcoach.io",
  };
};
